'use strict';
import {currency} from "../../services/constants/currency";

export default ['$filter', function($filter) {
    return function(amount, fraction = 0) {
        return $filter('currency')(amount, currency.getSign('usd'), fraction);
    };
}];



// WEBPACK FOOTER //
// ./_src/service_ui/billing/externalBillingCurrencyFilter.js